import {useCallback} from "react";
import GameListItem from "@/view/game/GameListItem";
import {GameData} from "@/service/GameService"


export interface GameParam {
    gameList: GameData[]
    onReturn: () => void
}

const GameList = (props: GameParam) => {
    const handleReturnClick = useCallback(() => {
        props.onReturn()}, [props.onReturn])

    if (props.gameList.length === 0) {
        return (
            <></>
        )
    } else {
        return (
            <>
                <div className="game-list">
                    {props.gameList.map((data, index) => (
                        <div key={index} className="mb-4px">
                            <GameListItem
                                game={data}
                                onReturn={handleReturnClick}
                            />
                        </div>
                    ))}
                </div>
            </>
        )
    }
}

export default GameList;